var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h3',{staticClass:"text-h3 text-md-h2 font-weight-black text-uppercase text-center text-md-left"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }